import React from 'react';

import { Chip, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  chipRoot: {
    backgroundColor: theme.palette.primary.main,
    width: theme.spacing(4.75),
    height: theme.spacing(4),
    paddingLeft: theme.spacing(1.625),
    display: 'inline-flex',
    '&:hover, &:focus, &:active': {
      backgroundColor: theme.palette.primary.main
    }
  },
  chipIcon: {
    color: theme.palette.common.white
  }
}));

interface ButtonLockedCTAProps {
  href: string
  size?: string
  hasTooltip: boolean
  tooltipTitle?: string | React.ReactNode
}

export function ButtonLockedCTA ({ href, size = 'base', hasTooltip = false, tooltipTitle }: ButtonLockedCTAProps) {
  const classes = useStyles();
  const chip = (
    <Chip
      clickable
      icon={<Icon size={size} type='lock' />}
      component='a'
      href={href}
      classes={{
        root: classes.chipRoot,
        icon: classes.chipIcon
      }}
    />
  );

  if (hasTooltip && tooltipTitle) {
    return (
      <Tooltip
        title={tooltipTitle}
        arrow
        placement='top-start'
      >
        {chip}
      </Tooltip>
    );
  }

  return chip;
}

export default ButtonLockedCTA;
